const valid = {
    /* 手机号码 */
    MobilePhoneNumber: /^1[3|5|7|8]\d{9}$/
    // MobilePhoneNumber: /^(\+)?(\d{2,3})?1\d{10}$/,
}

export default valid
